import {
  IBaseResponseApi,
  IfilteApi,
} from "../../Interfaces/gestionDocumentos/ITipoDocumento";
import { fetchAdministracion, fetchGestionDocumentos } from "../http-common";

// Listar pdfBlob en base 64
const crearTipoDocumento = (body: any) => {
  return fetchGestionDocumentos.post<IBaseResponseApi>(
    `TipoDocumentos/Crear`,
    body
  );
};

const actualizarTipoDocumento = (body: any) => {
  return fetchGestionDocumentos.post<IBaseResponseApi>(
    `TipoDocumentos/Editar`,
    body
  );
};

const deleteTipoDocumento = (tipoDocumentoId: string) => {
  return fetchGestionDocumentos.put<IBaseResponseApi>(
    `TipoDocumentos/Eliminar?TipoDocumentoId=${tipoDocumentoId}`
  );
};

const listarTipos = (filter: IfilteApi, controller = new AbortController()) => {
  return fetchGestionDocumentos.get(`TipoDocumentos/Listar`, {
    params: filter,
    signal: controller.signal,
  });
};

const tipoDocumentoService = {
  crearTipoDocumento,
  listarTipos,
  actualizarTipoDocumento,
  deleteTipoDocumento,
};

export default tipoDocumentoService;
